export default "__VITE_ASSET__Cx8v1Fku__"